"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.788 2.438a3.7 3.7 0 0 1 4.424 0l6.702 4.997A2.7 2.7 0 0 1 22 9.599v10.997a1.7 1.7 0 0 1-1.7 1.7H3.7a1.7 1.7 0 0 1-1.7-1.7V9.6a2.7 2.7 0 0 1 1.086-2.164l6.702-4.997Zm3.587 1.122a2.3 2.3 0 0 0-2.75 0L3.994 8.504a.733.733 0 0 1 .019.02l6.254 6.729c.564.56 1.173.802 1.74.802s1.175-.242 1.74-.802l6.24-6.729a.717.717 0 0 1 .019-.02L13.375 3.56ZM20.6 9.922l-4.592 4.952L20.6 20.36V9.921Zm-1.378 10.974-4.174-4.987-.284.306a.659.659 0 0 1-.018.019c-.788.788-1.743 1.221-2.739 1.221-.996 0-1.951-.433-2.739-1.221a.521.521 0 0 1-.018-.019l-.288-.31-4.179 4.991h14.44ZM3.4 20.368l4.601-5.497L3.4 9.921v10.447Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EmailOpenIcon24.js.map